import { render, staticRenderFns } from "./student-tree-chart.vue?vue&type=template&id=0ffb7bf1&scoped=true"
import script from "./student-tree-chart.ts?vue&type=script&lang=ts&external"
export * from "./student-tree-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./student-tree-chart.scss?vue&type=style&index=0&id=0ffb7bf1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffb7bf1",
  null
  
)

export default component.exports